import { Component, OnInit, Input } from '@angular/core';
import { Product } from 'src/app/models/Product';
import { FavoritesService } from 'src/app/services/favorites.service';
import { logos } from '../../data/logoData';

@Component({
  selector: 'app-favorites-item',
  templateUrl: './favorites-item.component.html',
  styleUrls: ['./favorites-item.component.css']
})
export class FavoritesItemComponent implements OnInit {
  @Input() product: any;
  hide: boolean;
  logos = logos;
  constructor(private favoritesService: FavoritesService) { }

  ngOnInit() {
    this.hide = false;
    console.log(this.product);
    this.product.forEach(p => {
      p.productName = p.productName.replace(/\\/, '');
    });
  }
  removeFromFavorites() {
    this.favoritesService.removeFromLocalStorage(this.product[0].productCode);
    this.hide = true;
  }

  openLink(url) {
    window.open(url, '_blank');
  }
}
